import React, { useState, useReducer } from 'react';
import { WithStyles, withStyles } from '@mui/styles';
import { ClassNameMap } from '@mui/styles/withStyles';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { UnknownObject } from '../../../../react-app-env';

import {
} from '@mui/material';

import CustomBackdrop from '../../../../components/CustomBackdrop';
import { Category, emergencyReducer, EmergencyRole } from '../Common';
import Steps from '../Common/components/Steps';

import { createStation } from './mutations';

import styles from './styles';

interface Props extends WithStyles<typeof styles>, RouteComponentProps {
  classes: ClassNameMap<string>,
  organisation_id?: string,
  categories: Category[],
  emergencyRoles: EmergencyRole[],
  handleFinish: (id: string) => void,
}

const CreateEmergency = ({ classes, history, organisation_id, categories, emergencyRoles, handleFinish }: Props): React.ReactElement => {
  
  const [emergency, dispatchEmergency] = useReducer(emergencyReducer, {
    name: '',
    description: '',
    categories: [],
    roles: [],
  });

  const [saving, setSaving] = useState<boolean>(false);

  const handleSave = async () => {
    setSaving(true);

    const item: UnknownObject = {
      ...emergency,
    };

    delete item.categories;
    delete item.roles;

    const insertVariables = {
      object: {
        ...item,
        organisation_id,
        description: emergency.description || undefined,
        category_assignments: {
          data: emergency.categories.map((i: Category) => ({
            organisation_id,
            category_id: i.id,
          })),
        },
        role_assignments: {
          data: emergency.roles.map((i: EmergencyRole, order_index: number) => ({
            organisation_id,
            role_id: i.id,
            order_index,
          })),
        },
      },
    };
    const emergency_id: string | undefined = await createStation(insertVariables);
    if (emergency_id) {
      setSaving(false);
      handleFinish(emergency_id);
    }
  };

  return (
    <>
      <Steps
        completeLabel="Create"
        emergency={emergency}
        categories={categories}
        roles={emergencyRoles}
        dispatch={dispatchEmergency}
        handleSave={handleSave} />
      {saving && <CustomBackdrop label="Creating Emergency" />}
    </>
  );
};

export default withRouter(withStyles(styles)(CreateEmergency));
